export default __webpack_public_path__ + "static/media/about-heading.111a9825.png";